import { Observable } from 'rxjs'
import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { UserCommentsGateway } from './user-comments-gateway'
import { WebUserComment } from '../models/web-user-comments'

@Injectable()
export class NetworkUserCommentsGateway extends UserCommentsGateway {
    constructor(private http: HttpClient) {
        super()
    }

    getUserCommentsData(userProfileID: number): Observable<WebUserComment[]> {
        return this.http.get<WebUserComment[]>('../api/getUserComments/' + userProfileID)
    }

    addUsercomments(userComments: WebUserComment, userProfileID: number): Observable<WebUserComment> {
        return this.http.post<WebUserComment>('../api/addUserComments/' + userProfileID, JSON.stringify(userComments))
    }
}
